import Slider from './components/slider';
import Filter from './components/filter';

new Filter('.block--job-ads');
new Slider('.block--images');